<template>
  <div>
    <v-btn v-if="!chatModal" fab :color="colors.success" @click="getComments()" class="commentBtn" style="z-index: 2">
      <v-icon>mdi-comment</v-icon>
    </v-btn>
    <div class="chat-modal" :style="{display: chatModal ? '' : 'none'}">
      <div class="chat-header">
        <span class="chat-header-title">نظرات</span>
        <v-btn fab text @click="chatModal = false" small class="chat-header-close-btn">
          <v-icon :color="colors.danger">mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="chat-content">
        <div v-for="comment in comments"
             :key="comment.id"
             :class="[currentUser.id === comment.student.id ? 'message-self-div' : 'message-div']">
          <div :class="[currentUser.id === comment.student.id ? 'message-self' : 'message']"
               :style="{backgroundColor: currentUser.id === comment.student.id ? colors.success : '#aba6a6'}">
            <div class="message-sender" v-if="!comment.file_url">{{ comment.student.name }}:</div>
            <div class="message-content" v-if="comment.file_url">
              <a :href="comment.file_url" target="_blank">
                {{ comment.student.name }} یک فایل به اشتراک گذاشت
              </a>
            </div>
            <div class="message-content" v-else>{{ comment.comment }}</div>
          </div>
          <div class="trash-div">
            <v-btn x-small fab :color="colors.danger" v-if="currentUser.isBroadcaster || currentUserIsAdmin" @click="deleteComment(comment.id)">
              <v-icon color="white">mdi-trash-can-outline</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
      <div class="chat-input">
        <v-text-field
            v-model="newComment"
            prepend-icon="mdi-send"
            filled
            clear-icon="mdi-close-circle"
            clearable
            :label="'چیزی بنویسید'"
            type="text"
            @keyup.enter="sendComment()"
            @click:append-outer="selectFile()"
            @click:prepend="sendComment()"
            @click:clear="clearInput"
        ></v-text-field>
        <input @change="fileSelected" type="file" id="file-input" style="display: none">
        <div class="scroll-on-x">
          <v-chip class="mr-1"
                  v-for="quickMessage in quickMessages"
                  @click="newComment = quickMessage"
                  :key="quickMessage">
            {{ quickMessage }}
          </v-chip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MeetingCommentDesktop",

  props: [
    'currentUser', 'echo', 'meetingId', 'colors', 'currentUserIsAdmin'
  ],

  data() {
    return {
      chatModal: false,
      newComment: null,

      comments: [],

      quickMessages: [
        'Be Right Back',
        'Back',
        'Hello',
        'bye',
        'Unstable Network',
        "Can't share audio",
        "Can't share video"
      ]
    }
  },

  methods: {
    sendComment() {
      let data = new FormData()
      data.append('meeting_id', this.meetingId)
      if (document.getElementById('file-input').files.length) {
        data.append('file', document.getElementById('file-input').files[0])
      } else {
        data.append('comment', this.newComment)
      }

      window.axios.post('/session/online-class/student/comments/new', data)
          .then(() => {
            this.newComment = null
          })
          .catch((err) => {
            console.log('Err Add Comment: ', err)
          })
    },

    selectFile() {
      let elem = document.getElementById('file-input');
      let evt = document.createEvent("MouseEvents");
      evt.initEvent("click", true, false);
      elem.dispatchEvent(evt);
    },

    fileSelected() {
      let file = document.getElementById('file-input').files[0]
      this.newComment = file.name
    },

    clearInput() {
      this.newComment = null
      document.getElementById('file-input').value = null
    },

    getComments() {
      window.axios.get('/session/online-class/student/comments/' + this.meetingId)
          .then((res) => {
            this.chatModal = true
            this.comments = res.data.data
            this.$nextTick(() => {
              this.scrollCommentToBottom()
            })
          })
          .catch((err) => {
            console.log(err)
          })
    },

    scrollCommentToBottom() {
      let objDiv = document.getElementsByClassName("chat-content")[0];
      objDiv.scrollTop = objDiv.scrollHeight;
    },

    deleteComment(commentID) {
      window.axios.get('/session/online-class/student/comments/delete/' + commentID)
          .then(() => {})
          .catch((err) => {
            console.log(err)
          })
    }
  },

  mounted() {
    /* LISTEN FOR SIGNAL OFFER FROM BROADCASTERS */
    this.echo.private(`meeting.${this.meetingId}`).listen(
        ".CommentAdded",
        ({data}) => {
          this.comments.push(data)
          this.$nextTick(() => {
            this.scrollCommentToBottom()
          })
        }
    );

    /* LISTEN FOR SIGNAL OFFER FROM BROADCASTERS */
    this.echo.private(`meeting.${this.meetingId}`).listen(
        ".CommentDeleted",
        ({data}) => {
          const index = this.comments.findIndex(
              (item) => item.id === data.id
          );
          this.comments.splice(index, 1);
        }
    );
  }
}
</script>

<style scoped>
.commentBtn {
  box-shadow: none !important;
  position: fixed !important;
  bottom: 20px !important;
  right: 20px !important;
  color: white !important;
}

.chat-modal {
  background-color: whitesmoke;
  z-index: 9999;
  width: 500px;
  min-height: 350px;
  height: 500px;
  min-width: 270px;
  position: fixed;
  bottom: 20px;
  right: 10px;
  border: 2px solid black;
  padding: 15px;
  border-radius: 20px;
}

.chat-content {
  overflow-y: scroll;
  min-height: 290px;
  height: 300px;
}

.scroll-on-x {
  overflow-x: scroll;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid black;
}

.chat-header-title {
  font-weight: bold;
}

.chat-header-close-btn {
  margin-top: -10px;
}

.message-self {
  border-radius: 20px;
  padding: 10px;
  max-width: 450px;
  width: 250px;
  margin-top: 5px;
}

.message-div {
  width: 100%;
  direction: ltr;
  display: inline-flex;
  text-align: right;
}

.message-self-div {
  width: 100%;
  display: inline-flex;
  direction: rtl;
}

.message {
  border-radius: 20px;
  padding: 10px;
  max-width: 450px;
  width: 250px;
  margin-top: 5px;
  direction: rtl;
}

.chat-input {
  z-index: 999999;
  position: absolute;
  width: 100%;
  right: 0;
  padding: 20px 20px 0;
  bottom: 0;
  white-space: nowrap;
}

.trash-div {
  align-self: center;
  margin-right: 5px;
  margin-left: 5px;
}

.message-content {
  overflow-wrap: anywhere;
}
</style>